import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { EnhancedForm, IdentityField, TextFieldAdapter } from 'components/enhanced';
import { useTranslation } from 'react-i18next';

interface UpdateSuperAdminSapIdDialogProps {
  onClose: () => void;
  onSubmit: (values: { admin_sap_id: string }) => void;
  open: boolean;
  sapId?: string | null;
  oldSapId?: string | null;
}

export default function UpdateSuperAdminSapIdDialog({
  onClose,
  onSubmit,
  open,
  sapId,
  oldSapId
}: UpdateSuperAdminSapIdDialogProps) {
  const translationPrefix = 'pages.product.edit';
  const { t } = useTranslation();
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>{t(`${translationPrefix}.sap_dialog_title`)}</DialogTitle>
      <DialogContent>
        <div className="py-4">
          <Typography variant="body2">
            {t(`${translationPrefix}.sap_id_old`)}: {oldSapId || '-'}
          </Typography>
        </div>
        <EnhancedForm onSubmit={onSubmit} formId="updateAdminSapId" hideControls>
          <IdentityField
            name="admin_sap_id"
            label={t(`${translationPrefix}.sap_id_label`)}
            initialValue={sapId || ''}
            component={TextFieldAdapter}
          />
        </EnhancedForm>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t(`actions.cancel`)}</Button>
        <Button type="submit" form="updateAdminSapId" variant="contained">
          {t(`actions.confirm`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
